import React, { useState } from 'react';
import {
  Card,
  CardBody,
  CardHeader,
  Input,
  Button,
  Link
} from '@heroui/react';
import { Mail, ArrowLeft, AlertCircle, CheckCircle } from 'lucide-react';

const ForgotPasswordPage = ({ onBackToLogin }) => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email.trim()) {
      setError('Por favor, digite seu email');
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      const formData = new FormData();
      formData.append('email', email);
      
      const response = await fetch('/api/v1/forgot_password', {
        method: 'POST',
        credentials: 'include',
        body: formData
      });

      if (response.ok) {
        setSuccess(true);
      } else {
        const data = await response.json();
        setError(data.error || 'Erro ao enviar email de recuperação');
      }
    } catch (error) {
      console.error('Forgot password error:', error);
      setError('Erro de rede. Tente novamente.');
    } finally {
      setIsLoading(false);
    }
  };

  if (success) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
        <div className="w-full max-w-md">
          <Card>
            <CardBody className="text-center p-8">
              <div className="space-y-4">
                <CheckCircle className="w-16 h-16 text-success-500 mx-auto" />
                <h2 className="text-2xl font-bold text-success-700">Email Enviado!</h2>
                <p className="text-gray-600">
                  Verifique sua caixa de entrada e siga as instruções para redefinir sua senha.
                </p>
                <Button
                  color="primary"
                  size="lg"
                  className="w-full"
                  onPress={onBackToLogin}
                >
                  Voltar ao Login
                </Button>
              </div>
            </CardBody>
          </Card>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-primary rounded-2xl mb-4">
            <span className="text-white font-bold text-2xl">U</span>
          </div>
          <h1 className="text-3xl font-bold text-gray-900">Recuperar Senha</h1>
          <p className="text-gray-600 mt-2">
            Digite seu email para receber instruções
          </p>
        </div>

        <Card>
          <CardHeader>
            <div className="flex flex-col space-y-1">
              <h2 className="text-xl font-bold">Esqueceu sua senha?</h2>
              <p className="text-gray-600 text-sm">
                Não se preocupe, vamos ajudá-lo a recuperar
              </p>
            </div>
          </CardHeader>

          <CardBody className="space-y-4">
            {error && (
              <div className="p-3 bg-danger-50 border border-danger-200 rounded-lg">
                <div className="flex items-center space-x-2">
                  <AlertCircle className="w-4 h-4 text-danger-600" />
                  <p className="text-danger-700 text-sm">{error}</p>
                </div>
              </div>
            )}

            <form onSubmit={handleSubmit} className="space-y-4">
              <Input
                label="Email"
                type="email"
                placeholder="Digite seu email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                startContent={<Mail className="w-4 h-4 text-gray-400" />}
                variant="bordered"
                isRequired
              />

              <Button
                type="submit"
                color="primary"
                size="lg"
                className="w-full"
                isLoading={isLoading}
              >
                Enviar Instruções
              </Button>
            </form>

            <div className="text-center">
              <Link
                color="primary"
                className="cursor-pointer"
                onPress={onBackToLogin}
                startContent={<ArrowLeft className="w-4 h-4" />}
              >
                Voltar ao Login
              </Link>
            </div>
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
